import script from "./ModalXL.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalXL.vue?vue&type=script&setup=true&lang=js"

import "./ModalXL.vue?vue&type=style&index=0&id=1b8fd73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8fd73c"]])

export default __exports__